




































import { Component, Vue } from "vue-property-decorator";
import AppHeader from "./AppHeader.vue";
import NotFound from "./NotFound.vue";

@Component({
  components: {
    AppHeader,
    NotFound
  }
})
export default class ServiceAdminPage extends Vue {
  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get service() {
    return this.$store.state.service;
  }

  canReadMaster() {
    return this.permissions.includes("service/master_read");
  }
}
